import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { ReactComponent as DNAIcon } from '../assets/icons/dna-icon.svg';
import SmallBanner from '../components/smallBanner';
import CounterTopdivider from '../assets/Images/layered-wave.svg';
import AboutImage1 from '../assets/Images/about1.png';
// import AboutImage2 from '../assets/Images/about2.png';
import AboutImage3 from '../assets/Images/About-img7.jpg';
import HeroShapeDividerBottom from '../assets/Images/intersecting-wave-layers.svg';
import MissionImage from '../assets/Images/mission-image.jpg';
import VisionImage from '../assets/Images/vision-image.jpg';
import MissionIcon from '../assets/Images/mision-Icon.png';
import VisionIcon from '../assets/Images/vision-icon.png';
import CerificateOne from '../assets/Images/certificate-1.png';
import CerificateTwo from '../assets/Images/certificate-2.png';
import CerificateThree from '../assets/Images/certificate-3.png';
import CerificateFour from '../assets/Images/certificate-4.png';
import CerificateFive from '../assets/Images/certificate-5.png';
import CerificateSix from '../assets/Images/certificate-6.png';
import CerificateSeven from '../assets/Images/certificate-7.png';
import CerificateEight from '../assets/Images/certificate-8.png';
import CerificateNine from '../assets/Images/certificate-9.png';
import CerificateTen from '../assets/Images/certificate-10.png';
import CerificateEleven from '../assets/Images/certificate-11.png';
import Cerificate12 from '../assets/Images/certificate-12.png';
import Cerificate13 from '../assets/Images/certificate-13.png';
import Cerificate14 from '../assets/Images/certificate-14.png';
import Service01 from '../assets/Images/About-img1.jpeg';
import Service02 from '../assets/Images/About-img5.jpg';
import Service03 from '../assets/Images/About-img2.jpeg';
import service04 from '../assets/Images/About-img3.jpeg';
import Founder from '../assets/Images/founder.png';
import ManufacturingUnit from '../assets/Images/About-img8.jpg';
import ManufacturingUnit1 from '../assets/Images/manufacture-image-1.png';
// import OurOffice from '../assets/Images/office 4.jpeg';
// import OurOffice1 from '../assets/Images/office 3.jpeg';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
// import Certificate1 from '../assets/Images/certificate1.PNG';
// import Certificate2 from '../assets/Images/certificate2.PNG';

import 'swiper/css';

const About = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1
    });


    return (
        <main className='about-page'>
            <SmallBanner Heading={'About us'} />

            <section className="about-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="row position-relative z-1" >
                                <img src={AboutImage1} alt="About" width="100%" height="100%" />
                                <img src={ManufacturingUnit} className='about-image-2 about-img infinite-slide' alt="About" width="100%" height="100%" />
                                <img src={AboutImage3} className='about-image-3 about-img infinite-slide2' alt="About" width="100%" height="100%" />
                            </div>

                        </div>
                        <div className="col-lg-6 ps-lg-5 mt-lg-0 pt-lg-0 pt-5 mt-5" data-aos="fade-left" data-aos-duration="2000">
                            <div className="banner-subtitle secondary-text"><DNAIcon /> About us</div>
                            <h2 className='section-title my-sm-2 my-0'>Empowering Global Healthcare Through Reliable Pharmaceutical Supply</h2>
                            <p className='para-text my-3'>Avna Pvt Ltd is an international export company providing high-quality pharmaceutical, nutraceutical, and surgical healthcare products to global markets. <br></br>

                                Working with certified manufacturing partners, we supply a wide portfolio of products while maintaining strict quality standards and competitive pricing.<br></br>

                                Our services include:</p>
                            <ul className='icon-list'>
                                <li>Global pharmaceutical sourcing</li>
                                <li>Contract manufacturing support</li>
                                <li>Regulatory & export documentation</li>
                                <li>International logistics coordination</li>
                            </ul>
                            <p>We aim to build long-term partnerships with distributors, hospitals, and importers worldwide by delivering consistency, reliability, and trust.</p>
                        </div>
                    </div>
                </div>
                <div className="shape-divider-bottom">
                    <img src={HeroShapeDividerBottom} alt="shape-divider-bottom" width="100%"
                        height="auto" />
                </div>
            </section>

            <section className="founder-wrapper py-100 pb-0">
                <div className="container">
                    <div className="row justify-content-center align-items-center pb-5">
                        <div className="col-lg-12">
                            <div className="text-center">
                                <div className="banner-subtitle secondary-text"><DNAIcon /> Our Leadership Team</div>
                                <h2 className='section-title my-sm-2 my-0'>Pankaj Bhavsar (Founder & CEO)</h2>
                                <p className='para-text my-3 col-xl-10 mx-auto'>
                                    Pankaj Bhavsar is the Founder of Avna Pvt Ltd, focused on connecting global healthcare buyers with trusted pharmaceutical manufacturers in India. He leads the company’s vision of expanding international pharmaceutical trade and building strong global partnerships.</p>
                            </div>
                            <h3 className='fw-semibold text-center mb-4'>Our Team members</h3>
                            <div className="row row-gap-3">
                                <div className="col-lg-3">
                                    <div className="mv-box my-0 h-100">
                                        <h3 className='mv-title'>Neel Bhavsar</h3>
                                        <p className='fw-medium'>Global Business Development</p>
                                        <p className='mv-desc'>Neel leads international business development and manages relationships with distributors, importers, and healthcare partners across global markets.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="mv-box my-0 h-100">
                                        <h3 className='mv-title'>Dr. Priya Shah</h3>
                                        <p className='fw-medium'>Head – Regulatory Affairs</p>
                                        <p className='mv-desc'>Dr. Priya oversees regulatory compliance, product documentation, and international registrations to ensure all products meet global regulatory standards.</p>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="mv-box my-0 h-100">
                                        <h3 className='mv-title'>Amit Patel</h3>
                                        <p className="fw-medium">Head – Quality Assurance</p>
                                        <p className='mv-desc'>Amit ensures strict quality control and compliance with international pharmaceutical standards while coordinating with certified manufacturing partners.</p>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="mv-box my-0 h-100">
                                        <h3 className='mv-title'>Rohan Desai</h3>
                                        <p className='fw-medium'>Manager – International Sales</p>
                                        <p className='mv-desc'>Rohan manages global client relationships and supports distributors and importers with product inquiries, quotations, and order processing.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="mv-box my-0 h-100">
                                        <h3 className='mv-title'>Karan Joshi</h3>
                                        <p className='fw-medium'>Manager – Supply Chain & Logistics</p>
                                        <p className='mv-desc'>Karan coordinates procurement, packaging, and international shipments to ensure timely and efficient delivery to global markets.</p>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className="mv-box my-0 h-100">
                                        <h3 className='mv-title'>Anjali Trivedi</h3>
                                        <p className='fw-medium'>Manager – Product Sourcing</p>
                                        <p className='mv-desc'>Anjali works closely with pharmaceutical manufacturers to source high-quality products that meet client requirements and market demands.</p>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className="mv-box my-0 h-100">
                                        <h3 className='mv-title'>Vikas Sharma</h3>
                                        <p className='fw-medium'>Manager – Documentation & Compliance</p>
                                        <p className='mv-desc'>Vikas manages export documentation, certificates, and international compliance requirements to ensure smooth customs clearance and shipping.
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className="mv-box my-0 h-100">
                                        <h3 className='mv-title'>Sneha Kapoor</h3>
                                        <p className='fw-medium'>Manager – Client Support</p>
                                        <p className='mv-desc'>Sneha handles customer communication and post-order support, ensuring a smooth and professional experience for every client.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* <div className="col-lg-4 order-lg-0 order-1">
                            <img src={Founder} alt="Founder" className="founder w-100" />
                        </div> */}
                    </div>
                </div>
            </section>

            <section className='aboutus-wrapper py-100'>
                <div className="container">
                    <div className="row justify-content-center mb-lg-5 mb-4" data-aos="fade-up" data-aos-duration="3000">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />About industrie</div>
                            <h2 className='section-title my-sm-2 my-0'>Our Promise</h2>
                            <p className='para-text my-3 col-md-8 mx-auto'>Quality, reliability, and long-term partnerships. <br></br> At Avna Pvt Ltd, we are committed to delivering high-quality pharmaceutical and healthcare products while maintaining transparency, compliance, and dependable global supply. Our focus is to build trusted relationships with distributors, importers, hospitals, and healthcare organizations worldwide.</p>
                        </div>
                    </div>

                    <div className="row about-row-gap mx-0">
                        <div className="col-lg-6" data-aos="fade-right" data-aos-duration="3000">
                            <div className="row mx-0">
                                <div className='col-md-6 col-7'>
                                    <img src={MissionImage} className='mv-image' alt="Our vision" width="100%" height="100%" />
                                </div>
                                <div className='col-md-6 col-5 d-flex align-items-md-start align-items-center justify-content-center'>
                                    <img src={MissionIcon} className='mv-icon' alt="Our vision" width="100%" height="100%" />
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-md-4 col-sm-3 col-2"></div>
                                <div className="col-md-8 col-sm-9 col-10">
                                    <div className="mv-box">
                                        <h3 className='mv-title'>Our Strength</h3>
                                        <ul className="icon-list mv-desc">
                                            <li>Expertise in pharmaceutical product sourcing and global supply</li>
                                            <li>Strong network of WHO-GMP, EU-GMP, USFDA, SRA and CE certified manufacturers</li>
                                            <li>Professional handling of regulatory documentation and export compliance</li>
                                            <li>Efficient international logistics and supply chain management</li>
                                            <li>Wide portfolio of pharmaceuticals, nutraceuticals, surgical disposables, and healthcare products</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-left" data-aos-duration="3000">
                            <div className="row">
                                <div className='col-md-6 col-7'>
                                    <img src={VisionImage} className='mv-image' alt="Our vision" width="100%" height="100%" />
                                </div>
                                <div className='col-md-6 col-5 d-flex align-items-md-start align-items-center justify-content-center'>
                                    <img src={VisionIcon} className='mv-icon' alt="Our vision" width="100%" height="100%" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-3 col-2"></div>
                                <div className="col-md-8 col-sm-9 col-10">
                                    <div className="mv-box">
                                        <h3 className='mv-title'>Our Mision</h3>
                                        <p className='mv-desc'>
                                            Our mission is to become a trusted global pharmaceutical export partner, helping international buyers source safe, high-quality healthcare products from India with confidence. <br></br>
                                            We aim to make reliable healthcare solutions accessible to every market through quality, integrity, and strong partnerships.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="our-services-wrapper py-100" id="services">
                <div className="container">
                    <div className="row justify-content-center mb-lg-5 mb-4" data-aos="fade-up" data-aos-duration="3000">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Our services</div>
                            <h2 className='section-title my-sm-2 my-0'>End-to-End Solutions for Healthcare & Wellness Exports</h2>
                            <p className='para-text my-3 col-md-8 mx-auto'>At Avna Pvt Ltd, we do more than just supply products—we help brands grow globally with our expert services:</p>
                        </div>
                    </div>

                    <div className="row align-items-center pb-5">
                        <div className="col-lg-6 order-lg-0 order-1" data-aos="fade-right" data-aos-duration="3000">
                            <img src={Service03} alt="pharmaceutical" className="globe-img w-100" />
                        </div>
                        <div className="col-lg-6">
                            <h2 className='section-title my-sm-2 my-0'>Custom Formulations & Private Labeling</h2>
                            <p className='para-text my-3 col-xl-10'> Launch your own brand with premium-quality supplements & medicines.</p>
                        </div>
                    </div>

                    <div className="row align-items-center pb-5">
                        <div className="col-lg-6">
                            <h2 className='section-title my-sm-2 my-0'>Contract Manufacturing</h2>
                            <p className='para-text my-3 col-xl-10'>Scalable production with the highest safety & compliance standards.</p>
                        </div>
                        <div className="col-lg-6" data-aos="fade-left" data-aos-duration="3000">
                            <img src={service04} alt="pharmaceutical" className="globe-img w-100" />
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-lg-6 order-lg-0 order-1" data-aos="fade-right" data-aos-duration="3000">
                            <img src={Service01} alt="pharmaceutical" className="globe-img w-100" />
                        </div>
                        <div className="col-lg-6">
                            <h2 className='section-title my-sm-2 my-0'>Global Exports & Regulatory Support</h2>
                            <p className='para-text my-3 col-xl-10'>Get your products registered & approved hassle-free.</p>
                        </div>
                    </div>
                    <div className="row align-items-center pb-5">
                        <div className="col-lg-6">
                            <h2 className='section-title my-sm-2 my-0'>Sourcing & Quality Assurance</h2>
                            <p className='para-text my-3 col-xl-10'>We deliver only the best, GMP-certified products.</p>
                        </div>
                        <div className="col-lg-6" data-aos="fade-left" data-aos-duration="3000">
                            <img src={Service02} alt="pharmaceutical" className="globe-img w-100" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="founder-wrapper py-100 pb-0">
                <div className="container">
                    <div className="row justify-content-around align-items-center pb-5 g-5">
                        <div className="col-lg-6  order-lg-0 order-1 position-relative abt-img-wrapper">
                            <img src={ManufacturingUnit1} alt="Our office" className="founder w-100" />
                            {/* <img src={OurOffice} className='about-image-5 about-img infinite-slide2' alt="manufacturing" width="100%" height="100%" />
                            <img src={OurOffice1} className='about-image-4 about-img infinite-slide' alt="manufacturing" width="100%" height="100%" /> */}

                        </div>
                        <div className="col-lg-6 ">
                            <div className="banner-subtitle secondary-text"><DNAIcon /> Excellence in Every Process</div>
                            <h2 className='section-title my-sm-2 my-0'>Our Office & Manufacturing unit</h2>
                            <p className='para-text my-3 col-xl-10'>Our office serves as the center of planning, innovation, and client support, while our manufacturing unit ensures high-quality production with modern technology and strict quality control. Together, they reflect Avna Pvt. Ltd.’s commitment to delivering reliable pharmaceuticals, nutraceuticals, veterinary, and Ayurvedic products worldwide.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className='counter-wrapper'>
                <div className="divider-top">
                    <img src={CounterTopdivider} alt="shape-divider-bottom" width="100%"
                        height="auto" />
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Trusted Worldwide</div>
                            <h2 className='section-title my-sm-2 my-0'>Our Achievements in Numbers</h2>
                            <p className='para-text my-3'>Empowering Global Healthcare Through Our Expertise</p>
                        </div>
                    </div>
                    <div className="row" ref={ref}>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="counter-box">
                                <h3 className='count-title space-font'>
                                    {inView && <CountUp end={169} duration={12} />} <span>+</span>
                                </h3>
                                <p className='count-desc'>CTD Dossier</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="counter-box">
                                <h3 className='count-title space-font'>
                                    {inView && <CountUp end={359} duration={12} />} <span>+</span>
                                </h3>
                                <p className='count-desc'>Total registrations</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="counter-box">
                                <h3 className='count-title space-font'>
                                    {inView && <CountUp end={69} duration={12} />} <span>+</span>
                                </h3>
                                <p className='count-desc'>Countries</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="counter-box">
                                <h3 className='count-title space-font'>
                                    {inView && <CountUp end={159} duration={12} />} <span>+</span>
                                </h3>
                                <p className='count-desc'>Wholesalers world wide</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="divider-bottom">
                    <img src={CounterTopdivider} alt="shape-divider-bottom" width="100%"
                        height="auto" />
                </div>
            </section>

            <section className='certificate-wrapper'>
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Quality Global Outreach</div>
                            <h2 className='section-title my-sm-2 my-0'>Our Certifications</h2>
                            <p className='para-text my-3'>We are the largest exporter of pharmaceutical, nutraceutical, and cosmeceutical products into various countries across the world with quality and certifications that are simply unmatched, be it the EU-GMP approval, PIC/S approval, WHO-GMP approval, and USFDA approval.</p>
                        </div>

                        <div className="col-lg-12">
                            <Swiper
                                slidesPerView={1}
                                spaceBetween={0}
                                breakpoints={{
                                    576: {
                                        slidesPerView: 4,
                                        spaceBetween: 0,
                                    },
                                }}
                                loop={true}
                                speed={6000} // Adjust for smoother scrolling
                                autoplay={{
                                    delay: 0, // Continuous autoplay without delay
                                    disableOnInteraction: false, // Keep autoplay even after user interaction
                                }}
                                pagination={true}
                                modules={[Pagination, Autoplay]} // Ensure Autoplay module is included
                                className="certificateSlider"
                            >
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateOne} alt="Certificate one" width='100%' height="100%" />
                                        <span>CD & DA SRILANKA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateTwo} alt="Certificate two" width='100%' height="100%" />
                                        <span>NDA UGANDA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateThree} alt="Certificate three" width='100%' height="100%" />
                                        <span>NAFDAC NIGERIA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateFour} alt="Certificate four" width='100%' height="100%" />
                                        <span>MRA AZERBAIJAN</span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateFive} alt="Certificate five" width='100%' height="100%" />
                                        <span> MOH LIBYA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateSix} alt="Certificate six" width='100%' height="100%" />
                                        <span>MOH KUWAIT</span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateSeven} alt="Certificate six" width='100%' height="100%" />
                                        <span>U.S FOOD & DRUG </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateNine} alt="Certificate six" width='100%' height="100%" />
                                        <span>PPB KENYA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateTen} alt="Certificate six" width='100%' height="100%" />
                                        <span>WHO-GMP </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateEight} alt="Certificate six" width='100%' height="100%" />
                                        <span>MOH YEMEN </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateEleven} alt="Certificate six" width='100%' height="100%" />
                                        <span>FDA GHANA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Cerificate12} alt="Certificate six" width='100%' height="100%" />
                                        <span>DPM IVORY COAST </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Cerificate13} alt="Certificate six" width='100%' height="100%" />
                                        <span>ISO
                                            9001:2008 </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Cerificate14} alt="Certificate six" width='100%' height="100%" />
                                        <span>FDA  PHILIPPINES</span>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>

       

            <section className="cta-wrapper">
                <div className="container">
                    <div className="row py-100 pb-0 justify-content-center">
                        <div className="col-lg-10 ">
                            <div className="cta-box text-center">
                                <h2 className="section-title text-white col-md-10 mx-auto">Looking for a reliable supply partner? Let’s discuss your needs today!</h2>
                                <p className="para-text my-3  text-white">Contact us for custom formulations, private labeling, and bulk orders!
                                </p>
                                <Link to="/contact" className="mt-4 btn-grad d-inline-block mx-auto w-auto">
                                    Get a Free Consultation
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default About;